
import {Component, Mixins, Prop, Watch} from "vue-property-decorator";
import ObjectInputMixin from "@/mixins/ObjectInputMixin.vue";
import UyapAdliyePicker from "@/components/pickers/uyap/UyapAdliyePicker.vue";
import UcuncuSahisPicker from "@/components/pickers/uyap/UcuncuSahisPicker.vue";
import Dates from "@/components/inputs/Dates.vue";
import AvukatTalepTebligatTuruPicker from "@/components/pickers/uyap/AvukatTalepTebligatTuruPicker.vue";
import AvukatTalepAdresTuruPicker, {
  AvukatTalepAdresTuru
} from "@/components/pickers/uyap/AvukatTalepAdresTuruPicker.vue";
import TarafListPicker from "@/components/pickers/uyap/TarafListPicker.vue";
import {UyapHacizEvrakTuru} from "@/plugins/uyap-plugin/enum/uyap/evrak/UyapHacizEvrakTuru";
import DosyaAraciKisiKurumTarafListesiPicker from "@/components/pickers/uyap/DosyaAraciKisiKurumTarafListesiPicker.vue";
import FormDialog from "@/components/dialogs/FormDialog.vue";
import UcuncuTarafForm from "@/components/forms/form-wizard/eicrapro/UcuncuTarafForm.vue";
import IhbarnameTalepEvrakEntryForm from "@/components/forms/uyap-evrak/haciz-evrak/IhbarnameTalepEvrakEntryForm.vue";
import {Ihbarname89Params} from "@/plugins/uyap-plugin/haciz/HacizParamsInterfaces";
import {ITarafBilgisiDetayliTarafRollu} from "@/plugins/uyap-plugin/uyap/GetDosyaTarafListesiWithTarafRol";
import {dosyaAnahtari} from "@/utils/dosyaAnahtar";
import {ADRES_KODU, tebligatAdresiDegeri, tebligatAdresiYok} from "@/utils/tebligatAdresi";

@Component({
  computed: {
    AvukatTalepAdresTuru: () => AvukatTalepAdresTuru
  },
  components: {
    IhbarnameTalepEvrakEntryForm,
    UcuncuTarafForm,
    FormDialog,
    DosyaAraciKisiKurumTarafListesiPicker,
    TarafListPicker,
    AvukatTalepAdresTuruPicker, AvukatTalepTebligatTuruPicker, Dates, UcuncuSahisPicker, UyapAdliyePicker
  }
})
export default class IhbarnameTalepEvrakForm extends Mixins(ObjectInputMixin) {
  @Prop() dosyaId!: string;
  @Prop() tckn!: string;
  @Prop() vergiNo!: string;
  @Prop() borcluKisiKurumId!: number;
  @Prop() talepKodu!: number;
  @Prop() varsayilan!: string | boolean;
  @Prop() coklu!: string | boolean;
  @Prop({default: () => []}) secilenTakipler!: Array<any>;
  // coklu mod: önden çekilmiş 3. şahıs (taraf) listesi. Verilirse UYAP'a tekrar sorgu atılmaz.
  @Prop() tarafList!: ITarafBilgisiDetayliTarafRollu[];

  localValue!: any;
  uyapHacizEvrakTuru = UyapHacizEvrakTuru;
  kisiMi!: boolean;
  tarafFormData: any = {};
  alertGenisletildi = false;
  sorguProgress: boolean = false;
  // varsayilan mod: kişi satırı index'ine göre dosya arama metni
  aramaMetinleri: { [key: number]: string } = {};

  // coklu mod: üçüncü şahıs başına ayrı param
  entries: Ihbarname89Params[] = [];
  tarafItems: ITarafBilgisiDetayliTarafRollu[] = [];
  tarafListYukleniyor: boolean = false;

  cokluTarafHeaders = [
    {text: 'Seç', value: 'sec', sortable: false, width: '60px'},
    {text: '3. Şahıs', value: 'tarafAdi'}
  ];

  varsayilanKisiHeaders = [
    {text: 'Kişi', value: 'tarafAdi'},
    {text: 'Dosyalar', value: 'dosyalar', width: '65%'},
    {text: 'Kaldır', value: 'kaldir', sortable: false, width: '80px'}
  ];

  get isVarsayilan() {
    return this.varsayilan || this.varsayilan === "";
  }

  get isCoklu() {
    return this.coklu || this.coklu === "";
  }

  async created() {
    if (this.isCoklu) {
      this.entries = Array.isArray(this.value) ? this.value : [];
      await this.initTarafList();
    }
  }

  @Watch('value')
  onValueChangeEntries() {
    if (this.isCoklu)
      this.entries = Array.isArray(this.value) ? this.value : [];
  }

  // ---- coklu ----
  async initTarafList() {
    if (Array.isArray(this.tarafList)) {
      this.tarafItems = [...this.tarafList];
    } else {
      await this.loadTarafList();
    }
  }

  async loadTarafList() {
    try {
      this.tarafListYukleniyor = true;
      this.tarafItems = await this.$uyap.GetDosyaTarafListesiWithTarafRol().run({
        dosyaId: this.dosyaId,
        islemTuru: 26
      });
    } catch (e) {
      this.$toast.error(e.message);
    } finally {
      this.tarafListYukleniyor = false;
    }
  }

  isTarafSecili(item: ITarafBilgisiDetayliTarafRollu): boolean {
    return this.entries.some((e: Ihbarname89Params) => e.kisiKurumId === item.guncelKisiKurumId);
  }

  toggleTaraf(item: ITarafBilgisiDetayliTarafRollu, secili: boolean) {
    if (secili) {
      if (this.entries.some((e: Ihbarname89Params) => e.kisiKurumId === item.guncelKisiKurumId))
        return;
      const entry = new Ihbarname89Params();
      entry.kisiKurumId = item.guncelKisiKurumId;
      entry.kurumAdi = item.tarafAdi;
      this.entries.push(entry);
    } else {
      const idx = this.entries.findIndex((e: Ihbarname89Params) => e.kisiKurumId === item.guncelKisiKurumId);
      if (idx > -1) this.entries.splice(idx, 1);
    }
    this.emitEntries();
  }

  async onTarafKaydedildi() {
    const oncekiIdler = new Set(this.tarafItems.map((t) => t.guncelKisiKurumId));
    await this.loadTarafList();
    const yeniTaraf = this.tarafItems.find((t) => !oncekiIdler.has(t.guncelKisiKurumId));
    if (yeniTaraf) this.toggleTaraf(yeniTaraf, true);
    this.tarafFormData = {};
  }

  updateEntry(index: number, val: Ihbarname89Params) {
    this.$set(this.entries, index, val);
    this.emitEntries();
  }

  removeEntry(index: number) {
    this.entries.splice(index, 1);
    this.emitEntries();
  }

  emitEntries() {
    this.$emit('input', this.entries);
  }

  // ---- varsayilan ----
  get dosyaItems() {
    // Anahtar dosyaId olamaz: Excel ile yüklenen takiplerde hiç gelmiyor, UYAP'tan
    // gelende ise bayatlıyor. Kararlı kimlik birimId + dosyaNo (bkz. dosyaAnahtari).
    return this.secilenTakipler.map((takip: any) => ({
      dosyaNo: takip.dosyaNo + ' - ' + takip.birimAdi,
      dosyaKey: dosyaAnahtari(takip)
    }));
  }

  get bosDosyaItems() {
    const atananlar = (this.localValue.kisiler || []).flatMap((k: any) => k.dosyalar || []);
    return this.dosyaItems.filter((d: any) => !atananlar.includes(d.dosyaKey));
  }

  get bosDosyaSayisi() {
    return this.bosDosyaItems.length;
  }

  get baziDosyalarBos() {
    return this.bosDosyaSayisi > 0 && this.bosDosyaSayisi < this.dosyaItems.length;
  }

  getAvailableDosyaItemsForKisi(kisi: any) {
    // Çoklu üçüncü şahıs için kısıt kaldırıldı: aynı dosya birden çok şahsa atanabilir.
    return this.dosyaItems;
  }

  setArama(index: number, arama: string | null) {
    this.$set(this.aramaMetinleri, index, arama || '');
  }

  // Kullanıcı arama kutusuna yazdıysa "tümünü seç" sadece ekranda görünen (filtrelenen) dosyalara uygulanır.
  // Filtre, Vuetify'ın varsayılan filtresiyle birebir aynı şekilde çalışır ki seçilenler görünenlerle örtüşsün.
  gorunenDosyaItems(kisi: any, index: number) {
    const items = this.getAvailableDosyaItemsForKisi(kisi);
    const arama = (this.aramaMetinleri[index] || '').toLocaleLowerCase();
    if (!arama) return items;
    return items.filter((d: any) => String(d.dosyaNo).toLocaleLowerCase().indexOf(arama) > -1);
  }

  gorunenSecimDurumu(kisi: any, index: number) {
    const gorunenIdler = this.gorunenDosyaItems(kisi, index).map((d: any) => d.dosyaKey);
    const secililer = kisi.dosyalar || [];
    const seciliSayisi = gorunenIdler.filter((id: string) => secililer.includes(id)).length;
    return {
      gorunenIdler,
      seciliSayisi,
      tumu: gorunenIdler.length > 0 && seciliSayisi === gorunenIdler.length,
      filtreliMi: !!this.aramaMetinleri[index]
    };
  }

  tumunuSecLabel(kisi: any, index: number): string {
    const durum = this.gorunenSecimDurumu(kisi, index);
    if (durum.filtreliMi)
      return (durum.tumu ? 'Filtrelenenleri Kaldır' : 'Filtrelenenleri Seç') + ' (' + durum.gorunenIdler.length + ')';
    return durum.tumu ? 'Tüm Seçimi Kaldır' : 'Tümünü Seç (' + durum.gorunenIdler.length + ')';
  }

  tumDosyalarIcon(kisi: any, index: number): string {
    const durum = this.gorunenSecimDurumu(kisi, index);
    if (durum.tumu)
      return 'mdi-close-box';
    if (durum.seciliSayisi > 0)
      return 'mdi-minus-box';
    return 'mdi-checkbox-blank-outline';
  }

  secimIkonRengi(kisi: any, index: number): string {
    return this.gorunenSecimDurumu(kisi, index).seciliSayisi > 0 ? 'primary' : '';
  }

  tumDosyalariSecToggle(kisi: any, index: number) {
    const durum = this.gorunenSecimDurumu(kisi, index);
    const secililer = kisi.dosyalar || [];
    // Görünenlerin hepsi seçiliyse sadece görünenleri kaldır, filtre dışındaki seçimlere dokunma.
    const yeniSecim = durum.tumu
        ? secililer.filter((id: string) => !durum.gorunenIdler.includes(id))
        : Array.from(new Set([...secililer, ...durum.gorunenIdler]));
    this.$set(kisi, 'dosyalar', yeniSecim);
    this.input();
  }

  dosyaKaldir(kisi: any, dosyaKey: string) {
    this.$set(kisi, 'dosyalar', (kisi.dosyalar || []).filter((k: string) => k != dosyaKey));
    this.input();
  }

  onTarafEklendi(tarafData: any) {
    if (!this.localValue.kisiler) {
      this.$set(this.localValue, 'kisiler', []);
    }
    // Çoklu atamaya izin verildiği için yeni şahsa tüm dosyalar varsayılan atanır.
    const tumDosyaIds = this.dosyaItems.map((d: any) => d.dosyaKey);
    this.localValue.kisiler.push({
      ...tarafData,
      dosyalar: tumDosyaIds
    });
    this.tarafFormData = {};
    this.input();
  }

  kisiKaldir(index: number) {
    this.localValue.kisiler.splice(index, 1);
    // arama metinleri satır index'ine bağlı; satır silinince kaymasın diye sıfırlanır
    this.aramaMetinleri = {};
    this.input();
  }

  // ---- tekli ----
  get adresRule() {
    if (this.localValue.adresTuru == AvukatTalepAdresTuru.YENI) {
      if (!this.localValue.adres)
        return 'Lütfen bu alanı doldurun';
      if (this.localValue.adres.length > 1000)
        return 'Maksimum 1000 karakter kullanılabilir';
    }
    return true;
  }

  @Watch('localValue.adresTuru')
  onAdresTuruChange() {
    // Varsayılan modda dosya bağlamı (dosyaId / 3. şahsın kisiKurumId'si) yok, sorgu atılamaz.
    if (this.isCoklu || this.isVarsayilan) return;
    if (this.localValue.adresTuru == AvukatTalepAdresTuru.E_TEBLIGAT ||
        this.localValue.adresTuru == AvukatTalepAdresTuru.MERNIS ||
        this.localValue.adresTuru == AvukatTalepAdresTuru.MERSIS)
      this.adresSorgula();
  }

  /** Adres türüne karşılık gelen UYAP sorgu kodu; sorgu gerekmiyorsa null. */
  get adresSorguKodu(): string | null {
    switch (this.localValue.adresTuru) {
      case AvukatTalepAdresTuru.E_TEBLIGAT:
        return ADRES_KODU.E_TEBLIGAT;
      case AvukatTalepAdresTuru.MERNIS:
        return ADRES_KODU.MERNIS;
      case AvukatTalepAdresTuru.MERSIS:
        return ADRES_KODU.MERSIS;
      default:
        // YENI elle yazılıyor; VEKILIN_E_TEBLIGAT için sorgu kodu bilinmiyor.
        return null;
    }
  }

  /**
   * Adres BORÇLU için değil ÜÇÜNCÜ ŞAHIS için sorgulanır; ihbarname ona tebliğ ediliyor.
   * tckn/vergiNo prop'ları borçluya ait (TopluHacizTalepDuzenleForm: borcluBilgileri.*),
   * bu yüzden eski KisiMernisAdresiVarmi / GetKurumMersisAdresi sorguları yanlış kişiye
   * bakıyordu. Ayrıntı ve HAR referansları için bkz. utils/tebligatAdresi.ts
   */
  async adresSorgula() {
    this.sorguProgress = true;
    try {
      const kod = this.adresSorguKodu;
      if (kod) {
        this.localValue.adres = await this.tebligatAdresiCoz(kod);
        this.input();
      }
    } catch (e: any) {
      console.error("adresSorgula hatası:", e);
      this.$toast.error(e?.message || "Adres sorgulanamadı.");
    } finally {
      // Sorgu patlasa da spinner takılı kalmasın diye finally'de.
      setTimeout(() => {
        this.sorguProgress = false
      }, 2000)
    }
  }

  async tebligatAdresiCoz(adresKodu: string): Promise<string> {
    try {
      const cevap = await this.$uyap.GetIcraTebligatTalebiAdresSorgula().run({
        dosyaId: this.dosyaId,
        kisiKurumId: this.borcluKisiKurumId,
        kayitId: this.localValue.kisiKurumId,
        adresTuru: adresKodu
      });
      return tebligatAdresiDegeri(cevap, adresKodu);
    } catch (e: any) {
      // Kayıt yoksa UYAP errorCode'lu cevap veriyor; teknik hatalar yutulmaz.
      if (e?.errorCode) return tebligatAdresiYok(adresKodu);
      throw e;
    }
  }
}
